/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { createContext } from "react";
import { QtmThemeSetting } from "./ThemeProvider.types";

/**
 * Type for the theme context object.
 */
export type QtmThemeContextType = {
  /** Current theme setting */
  themeSetting: QtmThemeSetting;

  /** Function for updating the context's themeSetting */
  setThemeSetting: (setting: QtmThemeSetting) => void;
};

/**
 * Context object with default context.
 */
export const QtmThemeContext = createContext<QtmThemeContextType>({
  themeSetting: "light",
  setThemeSetting: () => {},
});
